export const MIN_WORKOUT_DAYS = 2;
export const MAX_WORKOUT_DAYS = 5;

export const DAY_OPTIONS = [
  { value: 0, label: 'Monday' },
  { value: 1, label: 'Tuesday' },
  { value: 2, label: 'Wednesday' },
  { value: 3, label: 'Thursday' },
  { value: 4, label: 'Friday' },
  { value: 5, label: 'Saturday' },
  { value: 6, label: 'Sunday' },
];

export const ENVIRONMENT_OPTIONS = [
  { value: 'HOME', label: 'Home' },
  { value: 'GYM', label: 'Gym' },
];
